"use client"
import React from "react";
import { Box } from "@mui/material";
import { UpshotloaderContainer } from "./UpshotloaderStyle";

const UpshotLoader = () => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100vh"
    >
      <UpshotloaderContainer>
        <Box className="loaderoverlay"></Box>
        <Box className="Next-loader">
            <Box className="Lspinner"></Box>
            <Box className="loaderBrand">
                <svg
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                width="21.3px"
                height="33.9px"
                viewBox="0 0 21.3 33.9"
                enableBackground="new 0 0 21.3 33.9"
                xmlSpace="preserve"
                >
                <g>
                    <path
                    className="st0"
                    fill="#458BBA"
                    d="M15.3,13.6V23h0c0,0.1,0,0.2,0,0.2c0,2.6-2.1,4.6-4.6,4.6c-2.6,0-4.6-2.1-4.6-4.6c0-0.1,0-0.2,0-0.2h0v-9.5
                    l-6,3.5v6.3h0c0,5.8,4.8,10.6,10.6,10.6s10.6-4.7,10.6-10.6h0v-6.3L15.3,13.6z"
                    />
                    <polygon
                    className="st1"
                    fill="#E7354F"
                    points="5.9,9.1 10.6,6.5 15.3,9.1 15.3,9.1 21.2,12.4 21.2,5.8 16.5,3.2 16.5,3.2 10.6,0 4.8,3.2 0.1,5.8 
                    0.1,12.4 5.9,9.1"
                    />
                </g>
                </svg>
            </Box>
        </Box>
      </UpshotloaderContainer>
    </Box>
  );
};

export default UpshotLoader;
